import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Tabs,
  Tab,
  Divider,
} from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLayoutEffect } from "react";

import { BASE_URL } from "../../../constants";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { getFinancialYearDates } from "../../../utils/common";
import dayjs from "dayjs";
import { format } from "date-fns";
import UpdateIcon from "@mui/icons-material/Update";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { faUserNurse } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";

const toolbarOptions = [
  [{ header: "1" }, { header: "2" }, { font: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["bold", "italic", "underline", "strike"],
  [{ align: [] }],
  [{ color: [] }, { background: [] }],
  ["blockquote"],
  [{ script: "sub" }, { script: "super" }],
  [{ size: ["small", "medium", "large", "huge"] }],

  // ✅ Table Controls (Quill v2 syntax)
  [
    { table: "insert-table" },
    { table: "insert-row-above" },
    { table: "insert-row-below" },
    { table: "insert-column-left" },
    { table: "insert-column-right" },
    { table: "delete-row" },
    { table: "delete-column" },
    { table: "delete-table" },
  ],
];

const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};

Quill.register({ "modules/table-better": QuillTableBetter }, true);
const RadiologyReporting = () => {
  // Simulate the initialization data
  function initValue() {
    const html = `
    <table style="width: 216px" class="ql-table-better">
    <tbody>
      <tr>
        <td data-row="row-kbbt" width="72" class="">
          <p class="ql-table-block" data-cell="cell-pqbh">1</p>
        </td>
        <td data-row="row-kbbt" width="72" style="background-color: #4d99e6; " class="">
          <p class="ql-table-block" data-cell="cell-6vwb">2</p>
        </td>
        <td data-row="row-kbbt" width="72" style="background-color: #4d99e6; " class="">
          <p class="ql-table-block" data-cell="cell-sbdd">3</p>
        </td>
      </tr>
      <tr>
        <td data-row="row-j9rd" width="72" class="">
          <p class="ql-table-block" data-cell="cell-hbqz">4</p>
        </td>
        <td data-row="row-j9rd" width="72" class="">
          <p class="ql-table-block" data-cell="cell-kgtt">5</p>
        </td>
        <td data-row="row-j9rd" width="72" class="">
          <p class="ql-table-block" data-cell="cell-2pu4">6</p>
        </td>
      </tr>
      <tr>
        <td data-row="row-inie" width="72" class="">
          <p class="ql-table-block" data-cell="cell-x6xx">7</p>
        </td>
        <td data-row="row-inie" width="72" class="">
          <p class="ql-table-block ql-align-center" data-cell="cell-8axw">8</p>
        </td>
        <td data-row="row-inie" width="72" class="">
          <p class="ql-table-block ql-align-center" data-cell="cell-45td">9</p>
        </td>
      </tr>
    </tbody>
  </table>
    `;
    const editor = quillRef.current.getEditor();
    const delta = editor.clipboard.convert({ html });
    const [range] = editor.selection.getRange();
    editor.updateContents(delta, Quill.sources.USER);
    editor.setSelection(
      delta.length() - (range?.length || 0),
      Quill.sources.SILENT,
    );
    editor.scrollSelectionIntoView();
  }

  const location = useLocation();
  const navigate = useNavigate();
  const sentInvoice = location?.state?.sentInvoice || null;
  const report = location?.state?.report || null;
  const reportId = location?.state?.reportId || null;
  const reqType = location?.state?.reqType || null;
  const testDept = location?.state?.dept || null;
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [investigations, setInvestigations] = useState([]);
  const [resultRecord, setResultRecord] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDoctors, setSelectedDoctors] = useState({});
  const [submitUpdateTestId, setSubmitUpdateTestId] = useState(null);
  const [sampleCollectedDate, setSampleCollectedDate] = useState(
    format(new Date(), "MMMM d, yyyy"),
  );
  const [sampleCollectedTime, setSampleCollectedTime] = useState(
    format(new Date(), "hh:mm a"),
  );
  const [doctors, setDoctors] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [doctorName, setDoctorName] = useState([]);
  const [techniciansName, setTechniciansName] = useState([]);

  const quillRef = useRef(null);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link", "image"],
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: [false, "large"] }], // custom dropdown
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          // ['tableUI']
          ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    [],
  );

  const initializeInvestigations = (data) => {
    return data.map((item) => ({
      ...item,
      investigations: item.investigations.map((inv, index) => ({
        ...inv,
        inuse: index === 0,
      })),
    }));
  };

  const groupByTestDept = (data) => {
    return data.reduce((acc, item) => {
      const dept = item.testId.testDept;
      const existingGroup = acc.find((group) => group.testDept === dept);

      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        acc.push({
          testDept: dept,
          items: [item],
        });
      }

      return acc;
    }, []);
  };
  useEffect(() => {
    if (report && report.length > 0) {
      setSelectedInvoice(sentInvoice);
      setInvestigations(report);

      const testSignatoryMap = {};
      report[0].items.forEach((test) => {
        const testData = test.testId;
        const testId =
          typeof testData._id === "object" ? testData._id._id : testData._id;
        const doctorSignatories = testData.doctorSignatory || [];
        testSignatoryMap[testId] = doctorSignatories.map((ds) => ds.doctor._id);
      });
      setSelectedDoctors(testSignatoryMap);
    }
  }, [report, doctors]);

  const handleDateChange = (newDate) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format("MMMM D, YYYY");
      setSampleCollectedDate(formattedDate);
    }
    //setOpenModal(false);
  };

  const handleTimeChange = (newDate) => {
    if (newDate) {
      // Format the selected time as hh:mm AM/PM
      const formattedTime = format(new Date(newDate), "hh:mm a");
      setSampleCollectedTime(formattedTime);
    }
  };

  const fetchAllRadiologyDoctors = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-dept-signatory-doctors?cat=Radiology`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setDoctors(data.doctors);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
    }
  };
  const fetchAllTechnician = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-all-technicians`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (data.success) {
        setTechnicians(data.technicians);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
    }
  };

  const fetchAllInvoices = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/radiology/get-all-radiology-invoices?startDate=${
          getFinancialYearDates().startDate
        }&endDate=${getFinancialYearDates().endDate}&invoiceFor=radiology`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();

      setInvoices(data.invoices);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
  };

  useEffect(() => {
    fetchAllInvoices();
    fetchAllRadiologyDoctors();
    fetchAllTechnician();
  }, []);

  const fetchInvestigations = async (ids) => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/radiology/get-radiology-investigation-for-testIDs`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ testIDs: ids }),
        },
      );
      const data = await response.json();
      setInvestigations(
        groupByTestDept(initializeInvestigations(data.investigations)),
      );
      setResultRecord(data.investigations);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
    }
  };
  useEffect(() => {
    const ids = selectedInvoice?.tests
      ?.filter((test) => test.testId.testCat === "radiology")
      .map((test) => test.testId._id);
    ids && fetchInvestigations(ids);
    // const ids = selectedInvoice?.tests?.map((test) => test.testId._id);
    // ids && fetchInvestigations(ids);
  }, [selectedInvoice]);

  const formatDateAndTime = (timestamp) => {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    return `${formattedDate} | ${formattedTime}`;
  };
  const submitReport = async () => {
    const data = {
      patientId: selectedInvoice.patientId._id,
      doctorId: selectedInvoice.doctorId._id,
      testId: selectedInvoice?.tests?.filter(
        (test) => test.testId.testCat === "radiology",
      )[0].testId._id,
      // report,
    };
    try {
    } catch (err) {
      console.log(err);
    }
  };

  // const handleInvestigationChange = (testId, investigationId) => {
  //   setInvestigations((prevInvestigations) =>
  //     prevInvestigations.map((item) => {
  //       if (item.testId._id === testId) {
  //         return {
  //           ...item,
  //           investigations: item.investigations.map((inv) => ({
  //             ...inv,
  //             inuse: inv._id === investigationId,
  //           })),
  //         };
  //       }
  //       return item;
  //     })
  //   );
  // };
  const handleInvestigationChange = (testId, investigationId) => {
    setInvestigations((prevInvestigations) =>
      prevInvestigations.map((group) => {
        return {
          ...group,
          items: group.items.map((item) => {
            if (item?.testId?._id === testId) {
              return {
                ...item,
                investigations: item.investigations.map((inv) => ({
                  ...inv,
                  inuse: inv._id === investigationId,
                })),
              };
            }
            return item;
          }),
        };
      }),
    );
  };

  // const handleQuillChange = (testId, investigationId, content) => {
  //   setInvestigations((prevInvestigations) =>
  //     prevInvestigations.map((item) => {
  //       if (item.testId._id === testId) {
  //         return {
  //           ...item,
  //           investigations: item.investigations.map((inv) =>
  //             inv._id === investigationId
  //               ? { ...inv, testContent: content }
  //               : inv
  //           ),
  //         };
  //       }
  //       return item;
  //     })
  //   );
  // };
  const handleQuillChange = (testId, investigationId, content) => {
    setInvestigations((prevInvestigations) =>
      prevInvestigations.map((group) => ({
        ...group,
        items: group.items.map((item) => {
          if (item?.testId?._id === testId) {
            return {
              ...item,
              investigations: item.investigations.map((inv) =>
                inv._id === investigationId
                  ? { ...inv, testContent: content }
                  : inv,
              ),
            };
          }
          return item;
        }),
      })),
    );
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setDoctorName(typeof value === "string" ? value.split(",") : value);
  };
  const handleChange2 = (event) => {
    const {
      target: { value },
    } = event;
    setTechniciansName(typeof value === "string" ? value.split(",") : value);
  };

  const submitResult = async () => {
    try {
      // Prepare JSON data
      // setSubmitLoading(true);
      if (doctorName.length === 0) {
        alert("Please select at least one doctor");
        return;
      }
      if (techniciansName.length === 0) {
        alert("Please select at least one technician");
        return;
      }
      const result = {
        patientId: selectedInvoice?.patientId._id,
        doctorId: selectedInvoice?.doctorId._id,
        sampleCollectedDate,
        sampleCollectedTime,
        result: [...investigations],
        reportType: "radiology",
        invoice: selectedInvoice._id,
        doctorSignatory: doctorName,
        techSignatory: techniciansName,
      };
      // Send request
      console.log(result);
      const response = await fetch(
        `${BASE_URL}api/user/radiology/create-radiology-report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(result), // Send as multipart/form-data
        },
      );

      const data = await response.json();
      if (data.success) {
        alert("Results submitted successfully.");
        window.location.reload();
        // handlePrint(data.data.reportFileUrl);
      } else {
        alert("Failed to submit results.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      // setSubmitLoading(false);
    }
  };
  console.log(123, selectedInvoice);

  const [activeTab, setActiveTab] = useState(0);
  // 1) Derive active group & selected test **outside loops**
  const activeGroup = investigations[activeTab];
  console.log(1111, investigations);
  console.log(2222, activeGroup);
  const activeItem = activeGroup?.items[0]; // or whichever is currently selected in your UI

  // const selectedTest = activeItem?.investigations?.[0];
  const selectedTest =
    activeItem?.investigations?.find((inv) => inv.inuse) ||
    activeItem?.investigations?.[0];

  // 2) Update Quill only when selectedTest changes
  useLayoutEffect(() => {
    console.log("((((((((((", selectedTest);
    console.log("((((((((((", selectedTest?.testContent);
    if (!quillRef.current) return;
    if (!selectedTest?.testContent) return;

    const editor = quillRef.current.getEditor();
    const html = selectedTest?.testContent;
    const delta = editor.clipboard.convert({ html });
    const [range] = editor.selection.getRange();
    editor.setContents([], Quill.sources.SILENT);
    editor.updateContents(delta, Quill.sources.USER);
    editor.setSelection(
      delta.length() - (range?.length || 0),
      Quill.sources.SILENT,
    );
    editor.scrollSelectionIntoView();
    console.log("$$$$$$$$$$$$$$$$$$$$$$", selectedTest?.testContent);
  }, [selectedTest?._id]); // ✅ Use ID to avoid infinite loops

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // const submitGroupResult = async (group) => {
  //   try {
  //     const doctorsForTest = selectedDoctors[group.testId] || [];
  //     const result = {
  //       patientId: selectedInvoice?.patientId._id,
  //       doctorId: selectedInvoice?.doctorId._id,
  //       sampleCollectedDate,
  //       sampleCollectedTime,
  //       result: [group.itemData],
  //       reportType: "radiology",
  //       invoice: selectedInvoice._id,
  //       doctorSignatory: doctorsForTest,
  //     };
  //     const response = await fetch(
  //       `${BASE_URL}api/user/radiology/create-radiology-report`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(result),
  //       }
  //     );

  //     const data = await response.json();
  //     if (data.success) {
  //       alert(data.message);
  //       // Optionally reload or update local state
  //     } else {
  //       alert("Failed to submit results.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Something went wrong! Please try again.");
  //   }
  // };

  const submitGroupResult = async (group) => {
    try {
      const testData = group.itemData;
      setSubmitUpdateTestId(testData.testId._id);
      const doctorsForTest = selectedDoctors[testData.testId._id] || [];
      const formattedDoctorSignatories = doctorsForTest.map((doctorId) => ({
        doctor: doctorId,
        status: 1,
      }));
      const updatedTestData = {
        ...testData,
        testId: {
          ...testData.testId,
          doctorSignatory: formattedDoctorSignatories,
        },
      };

      const result = {
        patientId: selectedInvoice?.patientId._id,
        doctorId: selectedInvoice?.doctorId._id,
        sampleCollectedDate,
        sampleCollectedTime,
        result: [updatedTestData],
        reportType: "radiology",
        invoice: selectedInvoice._id,
      };
      const response = await fetch(
        `${BASE_URL}api/user/radiology/create-radiology-report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(result),
        },
      );

      const data = await response.json();
      if (!data.success) {
        toast.warning(data.message);
        return;
      }
      if (data.success) {
        toast.success(data.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);

        // Optionally refresh or update UI
      } else {
        toast.error("Failed to submit results.");
        return;
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong! Please try again.");
    } finally {
      setSubmitUpdateTestId(null);
    }
  };
  // const editReport = async (d) => {
  //   try {
  //     console.log(d.itemData);
  //     const testId = d.itemData.testId._id._id; // Extract testId from itemData
  //     const doctorsForTest = selectedDoctors[testId] || []; // Get selected doctors for this testId

  //     const itemDataWithDoctors = {
  //       ...d.itemData,
  //       selectedDoctors: doctorsForTest, // Add selected doctors to the payload
  //     };
  //     const response = await fetch(
  //       `${BASE_URL}api/user/radiology/update-radiology-report/${reportId}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify([itemDataWithDoctors]),
  //       }
  //     );

  //     const data = await response.json();
  //     if (data.success) {
  //       alert(data.message);
  //     } else {
  //       alert("Failed to submit results.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Something went wrong! Please try again.");
  //   }
  // };

  const editReport = async (d) => {
    try {
      const testData = d.itemData;
      const doctorsForTest = selectedDoctors[testData.testId._id._id] || [];
      setSubmitUpdateTestId(testData.testId._id._id);
      const formattedDoctorSignatories = doctorsForTest.map((doctorId) => ({
        doctor: doctorId,
        status: 1,
      }));

      const updatedTestData = {
        ...testData,
        testId: {
          ...testData.testId,
          doctorSignatory: formattedDoctorSignatories,
        },
      };
      const response = await fetch(
        `${BASE_URL}api/user/radiology/update-radiology-report/${reportId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify([updatedTestData]),
        },
      );

      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        // Optionally refresh or update UI
      } else {
        toast.error("Failed to submit results.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong! Please try again.");
    } finally {
      setSubmitUpdateTestId(null);
    }
  };

  const [selectedFormats, setSelectedFormats] = useState({});

  const resetReportForm = () => {
    setSelectedInvoice(null);
    setInvestigations([]);
    setResultRecord(null);
    setSelectedDoctors({});
    setDoctorName([]);
    setTechniciansName([]);
    setSelectedFormats({});
    setActiveTab(0);
    setOpenModal(false);
    setSampleCollectedDate(format(new Date(), "MMMM d, yyyy"));
    setSampleCollectedTime(format(new Date(), "hh:mm a"));
    fetchAllInvoices();
    navigate(location.pathname, { replace: true, state: null });
  };

  const handleInvChange = (testId, newFormatId) => {
    setSelectedFormats((prev) => ({
      ...prev,
      [testId]: newFormatId,
    }));
  };

  const handleDoctorChange = (testId, selectedDoctorIds) => {
    setSelectedDoctors((prev) => ({
      ...prev,
      [testId]: selectedDoctorIds,
    }));
  };
  const calculateAge = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();
    const diffInDays = today.diff(birthDate, "days");
    if (diffInDays < 30) {
      return `${diffInDays} days`;
    }
    let months = today.diff(birthDate, "months");
    if (today.date() < birthDate.date()) {
      months--;
    }
    if (months < 12) {
      return `${months} months`;
    }
    let years = Math.floor(months / 12);
    return `${years} years`;
  };
  return (
    <>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Change sample collected date</DialogTitle>
        <DialogContent
          sx={{
            paddingTop: "10px !important",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Appointment Date"
              value={
                sampleCollectedDate
                  ? dayjs(sampleCollectedDate, "MMMM D, YYYY") // Parse the date with the correct format
                  : null
              }
              onChange={handleDateChange}
              format="DD.MM.YYYY"
              maxDate={dayjs()} // Ensure the max date is today
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="Appointment Time"
              onChange={handleTimeChange}
              value={
                sampleCollectedTime
                  ? dayjs(sampleCollectedTime, "hh:mm a")
                  : null
              }
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
          {/* <Button
              onClick={() => setOpenModal(false)}
              variant="text"
              color="error"
            >
              Close
            </Button> */}
        </DialogContent>
      </Dialog>
      {!report && invoices?.length > 0 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={invoices}
              getOptionLabel={(option) =>
                `${option?.invoiceId} (${option?.patientId?.name} ~ ${option?.patientId?.patientID})`
              }
              onChange={(event, newValue) => {
                setSelectedInvoice(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Invoice"
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disableClearable
            />
          </Grid>
        </Grid>
      )}
      {selectedInvoice && investigations && (
        <>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              mt: 2,
              mb: 2,
              backgroundColor: "#f5f5f5",
              borderLeft: "5px solid #1976d2",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Name:</strong> {selectedInvoice?.patientId?.name}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Age:</strong>{" "}
                  {calculateAge(selectedInvoice?.patientId?.dob)}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Gender:</strong> {selectedInvoice?.patientId?.gender}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>Ref By:</strong> {selectedInvoice?.doctorId?.name}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1">
                  <strong>Registration ID: </strong>{" "}
                  {selectedInvoice?.invoiceId}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>Registration Date: </strong>{" "}
                  {formatDateAndTime(selectedInvoice?.createdAt)}
                </Typography>
                {/* <Typography
                  variant="subtitle1"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <strong style={{ marginRight: "5px" }}>
                    Sample Collected:
                  </strong>
                  {sampleCollectedDate} {sampleCollectedTime}
                  <UpdateIcon
                    sx={{
                      color: "#52b788",
                      marginLeft: 1,
                      "&:hover": { color: "#74c69d" },
                      cursor: "pointer",
                    }}
                    onClick={() => setOpenModal(true)}
                  />
                </Typography> */}
              </Grid>
            </Grid>
          </Paper>

          <Grid container spacing={2} mb={5}>
            <Grid item xs={12} sm={12}>
              <Box>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {console.log("TDDDD", testDept)}
                  {investigations[0]?.testDept ? (
                    investigations.map((group, idx) => (
                      <Tab key={idx} label={group.testDept} />
                    ))
                  ) : (
                    <Tab label={testDept} />
                  )}
                </Tabs>
                {investigations.map((group, idx) => (
                  <div key={idx} hidden={activeTab !== idx}>
                    {activeTab === idx && (
                      <Box>
                        {group.items.map((item, index) => {
                          const { testId, investigations: invList } = item;
                          const selectedTest =
                            invList.find((inv) => inv.inuse) || invList[0];

                          return (
                            <div
                              key={item._id}
                              style={{
                                marginTop: 7,
                                marginBottom: 20,
                                // border: "1px solid #353535",
                                // padding: "5px",
                                // borderRadius: "3px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Chip
                                  avatar={
                                    <Avatar
                                      sx={{
                                        backgroundColor: "#fb8500",
                                        borderRadius: "50%",
                                        width: "24px",
                                        height: "24px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        color: "white",
                                      }}
                                    >
                                      {index + 1}
                                    </Avatar>
                                  }
                                  label={testId.testName}
                                  sx={{ mb: 1 }}
                                />

                                {invList.length > 1 ? (
                                  <FormControl
                                    size="small"
                                    sx={{
                                      backgroundColor: "#d8f3dc",
                                      minWidth: 200,
                                    }}
                                  >
                                    <Select
                                      labelId={`format-label-${index}`}
                                      value={selectedTest._id}
                                      variant="filled"
                                      onChange={(e) =>
                                        handleInvestigationChange(
                                          testId._id,
                                          e.target.value,
                                        )
                                      }
                                    >
                                      {invList.map((inv) => (
                                        <MenuItem key={inv._id} value={inv._id}>
                                          {inv.formatName}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <Typography
                                    sx={{
                                      backgroundColor: "#caf0f8",
                                      minWidth: 200,
                                      padding: "11px",
                                      color: "#023e8a",
                                      borderBottom: "1px solid #023e8a",
                                    }}
                                  >
                                    {invList[0].formatName}
                                  </Typography>
                                )}
                              </div>
                              <ReactQuill
                                ref={quillRef}
                                theme="snow"
                                modules={modules}
                                onChange={(content) =>
                                  handleQuillChange(
                                    activeItem?.testId?._id,
                                    selectedTest?._id,
                                    content,
                                  )
                                }
                              />
                              {/* <ReactQuill
                                key={selectedTest._id} // <---- IMPORTANT
                                ref={quillRef}
                                theme="snow"
                                modules={modules}
                                defaultValue={selectedTest.testContent} // use defaultValue instead of value
                                onChange={(content) =>
                                  handleQuillChange(
                                    testId._id,
                                    selectedTest._id,
                                    content
                                  )
                                }
                              /> */}

                              {/* <ReactQuill
                                value={selectedTest.testContent}
                                placeholder="Define the test structure..."
                                modules={{ toolbar: toolbarOptions }}
                                onChange={(content) =>
                                  handleQuillChange(
                                    testId._id,
                                    selectedTest._id,
                                    content
                                  )
                                }
                              /> */}
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} md={9}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faUserDoctor}
                                      size="xl"
                                      style={{
                                        marginRight: "10px",
                                        background: "#cbf3f0",
                                        padding: "11px 15px",
                                        borderRadius: "5px",
                                        color: "#2ec4b6",
                                      }}
                                    />
                                    <FormControl fullWidth>
                                      <InputLabel
                                        id="demo-multiple-checkbox-label"
                                        size="small"
                                      >
                                        Signatory Doctor
                                      </InputLabel>
                                      <Select
                                        multiple
                                        size="small"
                                        value={
                                          selectedDoctors[
                                            reqType == "edit"
                                              ? testId._id._id
                                              : testId._id
                                          ] || []
                                        }
                                        onChange={(e) =>
                                          handleDoctorChange(
                                            // testId._id,
                                            reqType == "edit"
                                              ? testId._id._id
                                              : testId._id,
                                            e.target.value,
                                          )
                                        }
                                        input={
                                          <OutlinedInput label="Signatory Doctor" />
                                        }
                                        renderValue={(selected) => (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: 0.5,
                                            }}
                                          >
                                            {selected
                                              .map(
                                                (id) =>
                                                  doctors.find(
                                                    (d) => d._id === id,
                                                  )?.name,
                                              )
                                              .filter(Boolean)
                                              .map((name) => (
                                                <Chip key={name} label={name} />
                                              ))}
                                          </Box>
                                        )}
                                      >
                                        {selectedDoctors &&
                                          doctors?.map((doctor) => (
                                            <MenuItem
                                              key={doctor._id}
                                              value={doctor._id}
                                            >
                                              <Checkbox
                                                checked={
                                                  selectedDoctors[
                                                    // testId._id
                                                    reqType == "edit"
                                                      ? testId._id._id
                                                      : testId._id
                                                  ]?.includes(doctor._id) ||
                                                  false
                                                }
                                              />
                                              <ListItemText
                                                primary={doctor?.name}
                                              />
                                            </MenuItem>
                                          ))}
                                      </Select>
                                    </FormControl>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={3} display={"flex"}>
                                  {!report ? (
                                    <Button
                                      variant="contained"
                                      // color="success"

                                      onClick={() =>
                                        submitGroupResult({
                                          itemData: item,
                                          testId: testId._id,
                                        })
                                      }
                                      disabled={
                                        submitUpdateTestId === testId._id
                                      }
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#22c55e",
                                      }}
                                    >
                                      {submitUpdateTestId === testId._id
                                        ? "Submitting"
                                        : "Submit"}
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      color="warning"
                                      onClick={() =>
                                        editReport({
                                          itemData: item,
                                        })
                                      }
                                      disabled={
                                        submitUpdateTestId === testId._id._id
                                      }
                                      sx={{ width: "100%" }}
                                    >
                                      {submitUpdateTestId === testId._id._id
                                        ? "Updating"
                                        : "Update"}
                                      {console.log(
                                        "TTTTTTTTTTTT",
                                        testId._id._id,
                                      )}
                                    </Button>
                                  )}
                                </Grid>
                              </Grid>
                              <Divider
                                sx={{
                                  borderColor: "#83c5be", // blue divider
                                  borderWidth: 1,
                                  my: 3,
                                }}
                              />
                            </div>
                          );
                        })}
                      </Box>
                    )}
                  </div>
                ))}
              </Box>
            </Grid>
          </Grid>

          {/* <Card
            sx={{
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Soft shadow
              padding: "20px",
              backgroundColor: "#cce3de", // Clean white background
              mb: 10,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon
                    icon={faUserDoctor}
                    size="xl"
                    style={{ marginRight: 5 }}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="demo-multiple-checkbox-label" size="small">
                      Signatory Doctor
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={doctorName}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      input={<OutlinedInput label="Signatory Doctor" />}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#1976d2",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#115293",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#0d47a1",
                        },
                      }}
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                          }}
                        >
                          {selected
                            .map(
                              (id) =>
                                doctors.find((doctor) => doctor._id === id)
                                  ?.name
                            ) // Map ID to name
                            .filter(Boolean) // Remove undefined values
                            .map((name) => (
                              <Chip key={name} label={name} />
                            ))}
                        </Box>
                      )}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                      }}
                      //disabled={reqType === "approval"}
                    >
                      {doctors.map((doctor) => (
                        <MenuItem key={doctor._id} value={doctor._id}>
                          <Checkbox checked={doctorName.includes(doctor._id)} />
                          <ListItemText primary={doctor.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon
                    icon={faUserNurse}
                    size="xl"
                    style={{ marginRight: 5 }}
                  />

                  <FormControl fullWidth>
                    <InputLabel id="demo-multiple-checkbox-label" size="small">
                      Technician
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={techniciansName}
                      fullWidth
                      size="small"
                      onChange={handleChange2}
                      input={<OutlinedInput label="Technician" />}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#1976d2",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#115293",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#0d47a1",
                        },
                      }}
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                          }}
                        >
                          {selected
                            .map(
                              (id) =>
                                technicians.find((tech) => tech._id === id)
                                  ?.userName
                            ) // Map ID to name
                            .filter(Boolean) // Remove undefined values
                            .map((userName) => (
                              <Chip key={userName} label={userName} />
                            ))}
                        </Box>
                      )}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                      }}
                      //disabled={reqType === "approval"}
                    >
                      {console.log("$$", techniciansName)}
                      {technicians.map((tech) => (
                        <MenuItem key={tech._id} value={tech._id}>
                          <Checkbox
                            checked={techniciansName.includes(tech._id)}
                          />
                          <ListItemText primary={tech.userName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Card> */}

          {/* <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              zIndex: 10000,
            }}
          >
            <Box></Box>
            {investigations?.length > 0 && (
              <Box sx={{ display: "flex" }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    padding: "10px 20px",
                    backgroundColor: "#538d22",
                    textTransform: "none",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#73a942",
                      boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
                    },
                    borderRadius: "0",
                  }}
                  onClick={submitResult}
                >
                  <Typography>
                    Submit Report <AssessmentIcon sx={{ ml: 1 }} />
                  </Typography>
                </Button>
              </Box>
            )}
          </Box> */}
        </>
      )}
    </>
  );
};

export default RadiologyReporting;
